var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',[(typeof _vm.loading === 'boolean')?_c('p',[_vm._v(_vm._s(_vm.$t("utils.loading.default")))]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(`utils.loading.${_vm.loading}`))}}),_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"4x","spin":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }